import { render, staticRenderFns } from "./MainMenuNew.vue?vue&type=template&id=d89d5664&scoped=true&"
import script from "./MainMenuNew.vue?vue&type=script&lang=js&"
export * from "./MainMenuNew.vue?vue&type=script&lang=js&"
import style0 from "./MainMenuNew.vue?vue&type=style&index=0&id=d89d5664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89d5664",
  null
  
)

export default component.exports